<template>
	<div style="position: relative;">
		<v-container class="mt-12">
			<v-row>
				<v-col cols="12" md="6">
					<v-img :src="content.mainImg.src || `/NafisTheme/man.webp`" max-width="100%" :alt="`${businessTitle}-خرید اقساطی بدون ضامن`" />
				</v-col>
				<v-col cols="12" md="6">
					<h2 class="primary--text fs-h2 gradient-text">{{ content.title }}</h2>
					<p class="text-body-2 py-8 px-3 text-justify" style="line-height: 35px;white-space: pre-line;">
						{{ content.desc }}
						<br />
						<b>{{ businessTitle }} همراه مطمئن شما در مسیر خرید آسان.</b>
					</p>
				</v-col>
			</v-row>
		</v-container>

		<div v-if="editable" style="position: absolute;top: 0; left: 0;">
			<v-btn small color="secondary" outlined @click="edit()">ویرایش</v-btn>
		</div>

		<v-dialog v-model="settingsDialog" persistent max-width="650px">
			<v-card>
				<v-card-title>
					<div><span class="headline">تنظیمات خرید اعتباری</span></div>
					<v-spacer />
					<v-btn @click="settingsDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container v-if="settingsDialog">
						<v-row>
							<v-col cols="12" md="12" class="d-flex flex-column justify-center">
								<div class="text-center">تصویر اصلی</div>
								<ImageUploader :ref="'mainImageUploader'" v-model="settings.mainImg.src" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(settings.mainImg.src)" @delete="() => { settings.mainImg.src = '' }" />
							</v-col>
							<v-col cols="12">
								<v-text-field dense outlined v-model="settings.title" label="عنوان"></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-textarea dense outlined v-model="settings.desc" label="توضیحات"></v-textarea>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="settingsDialog = false">
						بستن
					</v-btn>
					<v-btn color="secondary" dark @click="submitEdit" :loading="submitEditLoading">
						ذخیره
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import { cloneDeep, isEmpty } from 'lodash'
	import { siteContentRootPath } from '@/util/enums'
	import { get } from 'vuex-pathify'
	import ImageUploader from '@/components/uploader/ImageUploader'
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'


	export default {
		name: 'NafisSection1',
		props: {
			data: { type: Object },
			contentKey: { type: String },
			editable: { type: Boolean }
		},
		components: {
			ImageUploader
		},
		data: () => ({
			settings: {},
			localData: null,
			settingsDialog: false,
			submitEditLoading: false
		}),
		computed: {
			...get('appSettings', [
				'landingSettings'
			]),
			...get('siteConfig', [
				'isCloud', 'fullTitle', 'customerCode'
			]),
			businessTitle() {
				return this.landingSettings?.businessTitle || this.fullTitle
			},
			content() {
				return this.localData?.content || this.defaultContent()
			},
			ccode() {
				return this.customerCode || this.$route.params.customerCode || 0
			}
		},
		mounted() {
			if (this.data) {
				this.localData = {
					id: this.data.id,
					key: this.data.key,
					isJson: this.data.isJson,
					content: JSON.parse(this.data.content)
				}
			}
			else {
				this.localData = {
					id: emptyId,
					key: this.contentKey,
					isJson: true,
					content: this.defaultContent()
				}
			}
		},
		methods: {
			defaultContent() {
				return {
					mainImg: { val: '', type: 'img', src: '/NafisTheme/man.webp' },
					title: `${this.businessTitle}، خرید اقساطی بدون ضامن`,
					desc: `با ${this.businessTitle}، دیگر دغدغه پرداخت نقدی نخواهید داشت. ما با ارائه طرح های متنوع عتباری، این امکان را فراهم کرده ایم تا
						بدون نیاز به ضامن، بتوانید کالاهای مورد نیاز خود از جمله لوازم خانگی، موبایل، لب تاپ، کالاهای دیجیتال و سایر خدمات را به صورت
						قسطی تهیه کنید.`
				}
			},
			edit() {
				this.settings = cloneDeep(this.content)
				this.settingsDialog = true
			},
			submitEdit() {
				this.submitEditLoading = true
				this.processImages().then(res => {
					const data = cloneDeep(this.localData)
					data.content = JSON.stringify(this.settings)
					api.post(`admin/SiteContent/CreateUpdate`, data)
						.then(response => {
							this.localData.content = cloneDeep(this.settings)
							toast.success('اطلاعات با موفقیت ذخیره شد.')
						})
						.catch(err => {
							toast.error(err.message)
						})
						.finally(x => { })
				}).catch(err => { })
					.finally(f => {
						this.submitEditLoading = false
						this.settingsDialog = false
					})
			},
			removeSlide(idx) {
				this.settings.slides.splice(idx, 1)
			},
			addSlide() {
				this.settings.slides.push({
					name: '',
					url: '',
					img: { val: '', type: 'img', src: '' }
				})
			},
			processImages() {
				return new Promise(async (resolve, reject) => {
					const formData = new FormData()
					var fileUploader = this.$refs.mainImageUploader
					if (fileUploader && fileUploader.hasFile()) {
						formData.append(`File`, fileUploader.getFile())
						formData.append(`fileName`, this.settings.mainImg.val)
						await api.post('admin/SiteContent/CreateUpdateImage', formData, { contentType: 'multipart/form-data' })
							.then(response => {
								this.settings.mainImg.val = response
								this.settings.mainImg.src = `${siteContentRootPath}${this.ccode}/${response}`
							})
							.catch(err => {
								toast.error(err.message)
								reject()
							})
							.finally(x => { })
					} else if (this.settings.mainImg.val && !this.settings.mainImg.src) {
						await api.post('admin/SiteContent/DeleteImage', { fileName: this.settings.mainImg.val })
							.catch(err => {
								toast.error(err.message)
								reject()
							})
					}
					resolve()
				})
			}
		},
	}
</script>

<style lang="scss"></style>